



















import { Component, Vue } from 'vue-property-decorator'
import AvatarForm from '@/components/account/AvatarForm.vue'
import ChangePasswordForm from '@/components/account/ChangePasswordForm.vue'
import ProfileForm from '@/components/account/ProfileForm.vue'

@Component({
  name: 'AccountPage',
  components: {
    AvatarForm,
    ChangePasswordForm,
    ProfileForm
  }
})
export default class AccountPage extends Vue {}
